import React from "react";
import { translate } from "react-i18next";
import {
  SendButton,
  Container,
  Input,
  Next,
  Previous,
  Controls
} from "./styles";

function Comment({
  index,
  length,
  enabled,
  comment,
  onPrevious,
  onNext,
  t,
  onValueChange,
  onSubmit,
  isntAnswered,
  isMovideskContext,
  onBlurCommentary
}) {
  return (
    <Container isMovideskContext={isMovideskContext}>
      {enabled && (
        <Input
          value={comment}
          onChange={({ target }) => onValueChange({ comment: target.value })}
          onBlur={() => !isntAnswered && onBlurCommentary()}
        />
      )}
      <div>
        <Controls>
          <Previous onClick={onPrevious} />
          <span>
            {index + 1}/{length}
          </span>
          <Next onClick={onNext} />
        </Controls>
        <SendButton disabled={isntAnswered} onClick={onSubmit}>
          {index + 1 === length ? t("send") : t("next")}
        </SendButton>
      </div>
    </Container>
  );
}

export default translate("translations")(Comment);
